module.exports = __webpack_public_path__ + "static/img/bg-two.c5f94c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-two.jpg
// module id = QiHW
// module chunks = 1